import React from "react";
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
} from "../../UI/Table";
import { useSortableTable } from "../../../hooks/useSortableTable";
import { useTooltip } from "../../../hooks/useTooltip";
import { formatDate } from "../../../utils/formatDate";

const OrganizerFundsTab = ({ data }) => {
  const { organizerFundsRequests } = data;
  const { showTooltip, hideTooltip } = useTooltip();

  const {
    sortedData: sortedRequests,
    handleSort,
    getSortIndicator,
  } = useSortableTable(organizerFundsRequests);

  const tableHeaders = [
    { key: "event_date", label: "Event Date", sortable: true },
    { key: "id", label: "Request ID", sortable: true },
    { key: "ip_address", label: "IP", sortable: true },
    { key: "request_amount", label: "Request Amount", sortable: true },
    { key: "account_name", label: "Account Name", sortable: true },
    { key: "account_number", label: "Account Number", sortable: true },
    { key: "routing_number", label: "Routing Number", sortable: true },
    { key: "status", label: "Status", sortable: true },
    { key: "request_date", label: "Request Date", sortable: true },
    { key: "request_type", label: "Request Type", sortable: true },
  ];

  if (sortedRequests.length === 0) {
    return (
      <div className="tab-content">
        <h3>Organizer Funds Request</h3>
        <div className="tab-empty">No organizer fund requests found.</div>
      </div>
    );
  }

  return (
    <div className="tab-content">
      <h3>Organizer Funds Request</h3>
      <Table>
        <TableHeader>
          {tableHeaders.map((header, index) => (
            <TableCell
              key={index}
              header
              onClick={
                header.sortable ? () => handleSort(header.key) : undefined
              }
              style={{
                cursor: header.sortable ? "pointer" : "default",
                userSelect: "none",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                {header.label}
                {header.sortable && getSortIndicator(header.key)}
              </div>
            </TableCell>
          ))}
        </TableHeader>
        <TableBody>
          {sortedRequests.map((fund) => (
            <TableRow key={fund.id}>
              <TableCell>
                {formatDate(fund.event_date)}
              </TableCell>
              <TableCell>{fund.id}</TableCell>
              <TableCell>{fund.ip_address}</TableCell>
              <TableCell className="row__amount">
                $
                {fund.request_amount.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </TableCell>
              <TableCell>
                {fund.account_name ? (
                  <div
                    className="rating-description"
                    onMouseEnter={(e) => showTooltip(e, fund.CheckAddress)}
                    onMouseLeave={hideTooltip}
                  >
                    <span className="tooltip-indicator">
                      {fund.account_name}
                    </span>
                  </div>
                ) : (
                  ""
                )}
              </TableCell>
              <TableCell>{fund.account_number}</TableCell>
              <TableCell>{fund.routing_number}</TableCell>
              <TableCell>
                <span
                  className={`status-badge status-${fund.status?.toLowerCase() ?? 'unknown'}`}
                >
                  {fund.status}
                </span>
              </TableCell>
              <TableCell>
                {formatDate(fund.request_date)}
              </TableCell>
              <TableCell>{fund.request_type}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default OrganizerFundsTab;
